module.exports = __webpack_public_path__ + "assets/img/ipt.c13d716c.jpg";